import axios from 'axios'

const checkOrder = async (orderId) => {
  try {
    const { data } = await axios.put('orders/updateCheck', { _id: orderId })
    return data
  } catch (err) {
    console.error('Error checking order:', err)
    throw err
  }
}

export default checkOrder
